import axios from '../config'
import { spm_api, micles_api, code_api, onlinetest_api } from '../baseURL'

export default {
    //获取数字教材用户
    getDigitalBookUser(fk_user_id, fk_class_id) {
        return axios.get(`${spm_api}/digitalUser/digitalUser?fk_class_id=${fk_class_id}&fk_user_id=${fk_user_id}`)
    },

    //设置用户操作记录
    setDigitalBookUser(data) {
        return axios.put(`${spm_api}/digitalUser/digitalUser`, data)
    },

    //获取微课信息
    getMicroLesson(id) {
        return axios.get(`${micles_api}/microLessonModel/${id}`)
    },

    //获取知识图谱数据
    getKnowledgeGraph(fk_class_id) {
        return axios.get(`${code_api}/knowledgeGraph?FK_ClassGuid=${fk_class_id}`)
    },

    // 获取试题知识点对应知识图谱数据
    getWrongQuestionRecord(data) {
        return axios.post(`${onlinetest_api}/wrongQuestionRecord`, data)
    }
}